import { createReducer } from 'redux-starter-kit';
import {putOverallBucketBalance} from "./overallBalanceActions";


/**
 * A selector for the overall bucket balance loaded in the domain state.
 */
export const selectOverallBucketBalance = state => state.via.domain.overallBucketBalance;


export default createReducer({}, {
  // Puts overall bucket balance into the state.
  [putOverallBucketBalance]: (state, action) => {
    const balance = action.payload;

    return {
      ...state,
      balance: balance,
    };
  },
});
